import { Fragment, useEffect, useState } from "react";
import { Skeleton, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import styles from "./ProgressoOS.module.css";
import { montarTrilha, tituloPorTipo } from "./nosVisuais";

function IconeCheck() {
  return (
    <svg className={styles.check} viewBox="0 0 24 24" fill="none">
      <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconeAviso() {
  return (
    <svg className={styles.iconeEstado} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 9v4m0 4h.01M10.29 3.86l-8.18 14.18A2 2 0 004.18 21h15.64a2 2 0 001.87-2.96L13.71 3.86a2 2 0 00-3.42 0z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconeCancelada() {
  return (
    <svg className={styles.iconeEstado} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth={2} />
      <path d="M9 9l6 6m0-6l-6 6" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    </svg>
  );
}

function ConteudoInformacao({ informacao }) {
  return (
    <div className={styles.tooltipInfo}>
      <div className={styles.tooltipInfoTitulo}>{informacao.titulo}</div>
      <p className={styles.tooltipInfoTexto}>{informacao.intro}</p>
      <ol className={styles.tooltipInfoLista}>
        {informacao.passos.map((passo, i) => (
          <li key={i}>{passo}</li>
        ))}
      </ol>
      <p className={styles.tooltipInfoTexto}>{informacao.outro}</p>
    </div>
  );
}

export function Processos({ situacaoId, tipoId, conselho }) {
  const [isLoading, setIsLoading] = useState(true);
  const sId = situacaoId?.id || situacaoId;
  const tId = String(tipoId?.id || tipoId);
  const temDadosNoConselho = conselho && typeof conselho === "object" && Object.keys(conselho).length > 0;

  useEffect(() => {
    if (sId && tId) setIsLoading(false);
  }, [sId, tId]);

  if (isLoading) {
    return (
      <div className={styles.wrapper}>
        <Skeleton active paragraph={{ rows: 1 }} />
      </div>
    );
  }

  if (sId === "C") {
    return (
      <div className={styles.wrapper}>
        <div className={styles.estadoCancelada}>
          <IconeCancelada />
          <span>Esta Ordem de Serviço foi cancelada.</span>
        </div>
      </div>
    );
  }

  const nos = montarTrilha(tId, sId, temDadosNoConselho);

  const existeNaTrilha = nos.some((no) => no.status === "atual" || no.status === "concluida");
  if (nos.length === 0 || !existeNaTrilha) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.estadoAviso}>
          <IconeAviso />
          <span>Situação "{sId}" ainda não mapeada na trilha de processo.</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.trilhaScroll}>
        <div className={styles.trilha}>
          {nos.map((no, index) => {
            const statusClasse =
              no.status === "concluida" ? styles.concluida : no.status === "atual" ? styles.atual : styles.pendente;
            const mostrarSelo = no.acao && no.status !== "concluida";

            const circulo = (
              <div className={`${styles.circulo} ${statusClasse}`}>
                {no.status === "concluida" ? <IconeCheck /> : index + 1}
                {mostrarSelo && <span className={styles.seloAcao}>!</span>}
              </div>
            );

            return (
              <div className={styles.etapa} key={no.chave}>
                {index > 0 && <div className={`${styles.conector} ${no.status !== "pendente" ? styles.preenchido : ""}`} />}
                {mostrarSelo && no.descricaoAcao ? <Tooltip title={no.descricaoAcao}>{circulo}</Tooltip> : circulo}
                <div className={`${styles.rotulo} ${statusClasse}`}>
                  {no.label}
                  {no.informacao && (
                    <Tooltip title={<ConteudoInformacao informacao={no.informacao} />} overlayClassName={styles.tooltipInfoOverlay}>
                      <InfoCircleOutlined className={styles.iconeInfo} />
                    </Tooltip>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Processos;
